
var onSale = false;
var soldOut = false;
var priceVaries = false;
var images = [];
var firstVariant = {};
// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.products_per_page,
        /* Optional */
        loadProductFirst: true,
        numberFilterTree: 2,
    },
};
// Declare Templates
var bcSfFilterTemplate = {
    // Grid Template
  'productGridItemHtml': '<div data-product-id="{{itemId}}" class="Grid__Cell 1/'+ bcSfFilterConfig.custom.mobile_row + '--phone 1/' + bcSfFilterConfig.custom.tablet_row + '--tablet-and-up 1/' + bcSfFilterConfig.custom.desktop_row + '--' + buildClass() +'">'+
                              '<div class="ProductItem '+ buildClassHiz() +'">'+
                                '<div class="ProductItem__Wrapper">'+
                                  '{{itemImages}}' +
                                  '{{itemWishlist}}' +
                                  '{{itemInfo}}'+
                                '</div>'+
                                buildButtonSecond() +
                              '</div>'+
                            '</div>',

    // Pagination Template
    'previousActiveHtml': '<a class="Pagination__NavItem Link Link--primary" rel="prev" href="{{itemUrl}}"><svg class="{{ icon_class }}" role="presentation" viewBox="0 0 11 18"><path d="M9.5 1.5L1.5 9l8 7.5" stroke-width="2" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path></svg></a>',
    'previousDisabledHtml': '',
    'nextActiveHtml': '<a class="Pagination__NavItem Link Link--primary" rel="next" href="{{itemUrl}}"><svg class="{{ icon_class }}" role="presentation" viewBox="0 0 11 18"><path d="M1.5 1.5l8 7.5-8 7.5" stroke-width="2" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path> </svg></a>',
    'nextDisabledHtml': '',
    'pageItemHtml': '<a class="Pagination__NavItem Link Link--primary" href="{{itemUrl}}">{{itemTitle}}</a>',
    'pageItemSelectedHtml': '<span class="Pagination__NavItem is-active">{{itemTitle}}</span>',
    'pageItemRemainHtml': '<span class="Pagination__NavItem">{{itemTitle}}</span>',
    'paginateHtml': ' <div class="Pagination Text--subdued"><div class="Pagination__Nav">{{previous}}{{pageItems}}{{next}}</div></div>',
    // Sorting Template
    'sortingHtml': '{{sortingItems}}',

};
/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
function prepareShopifyData(data) {
  // Displaying price base on the policy of Shopify, have to multiple by 100
  soldOut = !data.available; // Check a product is out of stock
  onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
  priceVaries = data.price_min != data.price_max; // Check a product has many prices
  // Convert images to array
  images = data.images_info;
  // Get First Variant (selected_or_first_available_variant)
  var firstVariant = data['variants'][0];
  if (getParam('variant') !== null && getParam('variant') != '') {
    var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
    if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
  } else {
    for (var i = 0; i < data['variants'].length; i++) {
      if (data['variants'][i].available) {
        firstVariant = data['variants'][i];
        break;
      }
    }
  }
  return data;
}
/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
/************************** BUILD PRODUCT LIST **************************/
// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {
  var isfreegift = false;
  for (let i = 0; i < data.tags.length; i++) {
    if(data.tags[i].indexOf('freegift') == 0){
      isfreegift = true;
    }
  }
  if(!isfreegift){
    // Get Template
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;

    // Custom ad
    if (bcSfFilterConfig?.custom?.ad_block_enable && bcSfFilterConfig?.custom?.ad_block_position && index == bcSfFilterConfig.custom.ad_block_position - 1) {
      itemHtml += '<div class="Grid__Cell 1/'+ bcSfFilterConfig.custom.mobile_row + '--phone 1/' + bcSfFilterConfig.custom.tablet_row + '--tablet-and-up 1/' + bcSfFilterConfig.custom.desktop_row + '--' + buildClass() +'">';
      itemHtml += '<div class="ProductItem grid-nonprod"><div class="ProductItem__Wrapper">';

      itemHtml += ( bcSfFilterConfig.custom.ad_block_url != '' ? '<a href="' + bcSfFilterConfig.custom.ad_block_url + '">' : '' ) +
          '<div class="AspectRatio AspectRatio--withFallback" style="max-width: 2017px;padding-bottom: ' + 100/bcSfFilterConfig.custom.ad_block_image_ratio + '%; --aspect-ratio: ' + bcSfFilterConfig.custom.ad_block_image_ratio + '">' +
          '<img src="' + bcSfFilterConfig.custom.ad_block_image + '" alt="' + bcSfFilterConfig.custom.ad_block_image_alt + '" />' +
          '</div>' +
          ( bcSfFilterConfig.custom.ad_block_url != '' ? '</a>' : '' );

      itemHtml += '<div class="ProductItem__Info ProductItem__Info--center">' +
          '<h2 class="2 ProductItem__Title Heading" role="heading" aria-level="3">' +
          ( bcSfFilterConfig.custom.ad_block_url != '' ? '<a href="' + bcSfFilterConfig.custom.ad_block_url + '">' : '' ) +
          bcSfFilterConfig.custom.ad_block_heading +
          ( bcSfFilterConfig.custom.ad_block_url != '' ? '</a>' : '' ) +
          '</h2>' +
          '<p class="sub_Heading" style="margin: 0;">' +
          bcSfFilterConfig.custom.ad_block_content +
          '</p>' +
          ( bcSfFilterConfig.custom.ad_block_url_text != '' ? '<a href="' + bcSfFilterConfig.custom.ad_block_url + '">' + bcSfFilterConfig.custom.ad_block_url_text + '</a>' : '' ) +
          '</div>';

      itemHtml += '</div></div>';

      itemHtml += '</div>';
    }

    // Customize API data to get the Shopify data
    data = prepareShopifyData(data);
    // Add Custom class
    var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
    var saleClass = onSale ? bcSfFilterTemplate.saleClass : '';
    // Add Images
    itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImage(data, images));

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemInfo}}/g, buildInfo(data, index));
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));
    
    // Build Domain
    itemHtml = itemHtml.replace(/{{itemDomain}}/g, this.escape(bcSfFilterConfig.shop.domain));

    // Build Description
    var itemDescription = data.description;
    itemDescription = itemDescription.substr(0, itemDescription.indexOf('##highlights##'));
    itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);

    // Build Tags
    itemHtml = itemHtml.replace(/{{itemTags}}/g, this.escape(data.tags.join(';')));

    /* Swym integration */ 
    var itemWishlistHtml = '<button class="wishlist-button swym-button swym-custom-collections swym-add-to-wishlist-view-product product_'+data.id+'" data-swaction="addToWishlist"  data-product-id="' + JSON.stringify(data.id) + '"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="33" height="33" viewBox="0 0 42 42"><defs><filter id="b_'+ JSON.stringify(data.id) +'" width="141.2%" height="141.2%" x="-20.6%" y="-14.7%" filterUnits="objectBoundingBox"><feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset><feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="2"></feGaussianBlur><feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.114756337 0"></feColorMatrix></filter><circle id="a_'+ JSON.stringify(data.id) +'" cx="17" cy="17" r="17"></circle></defs><g fill="none" fill-rule="evenodd" transform="translate(4 2)"><mask fill="#fff"><use xlink:href="#a"></use></mask><use fill="#000" filter="url(#b)" xlink:href="#a"></use><use fill="#FFF" xlink:href="#a"></use><g fill="#493069"><path d="M24.994 27.2a.86.86 0 01-.647-.29L17 18.5l-7.347 8.41a.866.866 0 01-.937.24.819.819 0 01-.556-.767V6.257c0-.451.379-.817.846-.817h15.988c.467 0 .846.366.846.817v20.126c0 .343-.222.65-.556.767a.872.872 0 01-.29.05zM17 16.418c.25 0 .486.106.647.29l6.501 7.44V7.073H9.852v17.075l6.501-7.44a.859.859 0 01.647-.29z"></path></g></g></svg></button>';
    itemHtml = itemHtml.replace(/{{itemWishlist}}/g, itemWishlistHtml);

    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    
    return itemHtml;
  }
};

/************************** END BUILD PRODUCT LIST **************************/
/************************** BUILD PRODUCT ITEM ELEMENTS **************************/
function buildClass() {
  return bcSfFilterConfig.custom.filter_position == 'drawer' ? 'lap-and-up' : 'desk';
}

function buildClassHiz() {
  return bcSfFilterConfig.custom.use_horizontal ? 'ProductItem--horizontal' : '';
}

function buildButtonSecond() {
  return bcSfFilterConfig.custom.use_horizontal ? '<a href="{{itemUrl}}" class="ProductItem__ViewButton Button Button--secondary hidden-pocket">' + bcSfFilterConfig.label.view_product + '</a>' : '';
}

function buildImage(data, images) {
  var htmlImg = '';
  if (!images) images = [];
  if (images.length == 0){
    images.push({
    	src: bcSfFilterConfig.general.no_image_url,
      	id: data.id,
      	width: 480,
      	height: 480
    });
  }

  let plp_video = data.tags.filter((v, i)=>{ if( v.split(":").length > 1 ){
    if(v.split(":")[0] == "plp_video"){
      return v;
    }
  }});

  if (images.length > 0) {
    htmlImg += '<a href="{{itemUrl}}" class="ProductItem__ImageWrapper ';
    var use_natural_size = false;
    var has_alternate_image = false;
    if (bcSfFilterConfig.custom.product_image_size == 'natural' || bcSfFilterConfig.custom.use_horizontal)
      use_natural_size = true;
    if (bcSfFilterConfig.custom.product_show_secondary_image && images.length > 1 && !bcSfFilterConfig.custom.use_horizontal)
      has_alternate_image = true;
    if (has_alternate_image)
      htmlImg += 'ProductItem__ImageWrapper--withAlternateImage';
    htmlImg += '">';
    var max_width = images[0].width;
    if (bcSfFilterConfig.custom.use_horizontal)
      max_width = 125;
    var withCall = use_natural_size ? 'withFallback' : bcSfFilterConfig.custom.product_image_size;
    htmlImg += '<div class="AspectRatio AspectRatio--' + withCall + '" style="max-width: ' + max_width + 'px;';
    var aspect_ratio = images[0].width / images[0].height;
    if (use_natural_size) {
      htmlImg += 'padding-bottom: ' + (100 / aspect_ratio) + '%;';
    }
    htmlImg += ' --aspect-ratio: ' + aspect_ratio + '">';
    if (has_alternate_image && images.length > 1) {
      var sizes = '200,300,400,600,800,900,1000,1200';
      var support_size = imageSize(sizes, images[1]);
      var thumbUrl = bcsffilter.optimizeImage(images[1]['src'], '{width}x');
      htmlImg += '<img class="ProductItem__Image ProductItem__Image--alternate Image--lazyLoad Image--fadeIn" data-src="' + thumbUrl + '" data-widths="[' + support_size + ']" data-sizes="auto" alt="' + data.title + '" data-image-id="' + images[1].id + '">';
    }

    var sizes_main = '200,400,600,700,800,900,1000,1200';
    var support_size = imageSize(sizes_main, images[0]);
    var thumbUrl_main = images.length > 0 ? bcsffilter.optimizeImage(images[0]['src'], '{width}x') : bcSfFilterConfig.general.no_image_url;
    htmlImg += '<img class="ProductItem__Image Image--lazyLoad Image--fadeIn" data-src="' + thumbUrl_main + '" data-widths="[' + support_size + ']" data-sizes="auto" alt="' + data.title + '" data-image-id="' + images[0].id + '">';
    htmlImg += '<span class="Image__Loader"></span>';
    htmlImg += '<noscript>';
    htmlImg += '<img class="ProductItem__Image ProductItem__Image--alternate" src="' + bcsffilter.optimizeImage(images[0]['src'], '600x') + '" alt="' + data.title + '">';
    htmlImg += '<img class="ProductItem__Image" src="' + bcsffilter.optimizeImage(images[0]['src'], '600x') + '" alt="' + data.title + '">';
    htmlImg += '</noscript>';
    htmlImg += '</div>';
    if( plp_video.length > 0 ){
      htmlImg += '<div id="video-tag" class="video-tag"><video loop muted><source src="'+ plp_video[0].replace("plp_video:", "") +'" type="video/mp4">Your browser does not support the video tag.</video></div>';
    }
    htmlImg += '</a>';
  }
  return htmlImg;
}


function buildVideo(data, indx) {
  let plp_video = data.tags.filter((v, i)=>{ if( v.split(":").length > 1 ){
    if(v.split(":")[0] == "plp_video"){
      return v;
    }
  }});

  if( plp_video.length > 0 ){
   return '<div id="video-tag" class="video-tag"><video loop muted><source src="'+ plp_video[0].replace("plp_video:", "") +'" type="video/mp4">Your browser does not support the video tag.</video></div>';
  }
}

function imageSize(sizes, image) {
  if (image) {
    var desired_sizes = sizes.split(',');
    var supported_sizes = '';
    for (var k = 0; k < desired_sizes.length; k++) {
      var size = desired_sizes[k];
      var size_as_int = size * 1;
      if (image.width < size_as_int) { break; }
      supported_sizes = supported_sizes + size + ',';
    }
    
    if (supported_sizes == '')
      supported_sizes = image.width;

    if(!jQ.isNumeric(supported_sizes)) {
      supported_sizes = supported_sizes.split(',').join(',');
      supported_sizes = supported_sizes.substring(0,supported_sizes.lastIndexOf(','));
    }
    return supported_sizes;
    
  } else {
    return '';
  }
}

function buildPrice(data) {
  var html = '';
  var show_price_on_hover = bcSfFilterConfig.custom.product_show_price_on_hover;
  var classPriceHover = show_price_on_hover ? 'ProductItem__PriceList--showOnHover' : '';
  var productid = data.id;
  var comp_at_price = data.selected_or_first_available_variant.compare_at_price;
  var main_price = data.selected_or_first_available_variant.price;
  if(comp_at_price == null){
    onSale = false;
  }
  else
  {
    onsale = true;
  }
  html += '<div class="ProductItem__PriceList ' + classPriceHover + ' Heading">';
  if (onSale) {
    // Calculate percentage savings
    var price_diff = comp_at_price - main_price;
    var percentage_saved = Math.round((price_diff * 100.0) / comp_at_price);

    html += '<span class="'+productid+'_compareatprice ProductItem__Price Price Price--compareAt Text--subdued" data-money-convertible>' + bcsffilter.formatMoney(comp_at_price, bcsffilter.moneyFormat, true) + '</span>';
  	html += '<span class="'+productid+'_mainprice ProductItem__Price Price Price--highlight Text--subdued" data-money-convertible>' + bcsffilter.formatMoney(main_price, bcsffilter.moneyFormat, true) + '</span> ';
    if( bcSfFilterConfig.custom.show_percentage_saved ) {
     html += '<span class="ProductItem__SavePercentage">(' + percentage_saved + '% Off)</span>';
    }
  } else {
    /*if (priceVaries) {
      html += '<span class="ProductItem__Price ProductItem__Price Price Text--subdued">' + bcsffilter.formatMoney(main_price, bcsffilter.moneyFormat, true) + '</span>';
    } else {*/
       html += '<span class="'+productid+'_compareatprice ProductItem__Price Price Price--compareAt Text--subdued" style="display: none;" data-money-convertible>' + bcsffilter.formatMoney(comp_at_price, bcsffilter.moneyFormat, true) + '</span>';
      html += '<span class="'+productid+'_mainprice ProductItem__Price Price Text--subdued" data-money-convertible>' + bcsffilter.formatMoney(main_price, bcsffilter.moneyFormat, true) + '</span>';
    //}
  }
  html += '</div>';
  return html;
}

function buildLabels(data) {
  var product_labels = ''
  if (bcSfFilterConfig.custom.show_labels) {
    product_labels = '';
    var tags = data.tags;
    for (var k = 0; k < tags.length; k++) {
      var tag = tags[k];
      if (tag.indexOf('__label') != -1) {
        product_labels += '<span class="ProductItem__Label Heading Text--subdued">' + tag.split('__label:')[1] + '</span>';
        break;
      }
    }
    if (!soldOut) {
      if (onSale)
        product_labels += '<span class="ProductItem__Badge-Content">' + bcSfFilterConfig.label.sale + '</span>';
    } else {
      product_labels += ' <span class="ProductItem__Label Heading Text--subdued">' + bcSfFilterConfig.label.sold_out + '</span>';
    }
    var html = '';
    if (product_labels != '') {
      html += '<span class="ProductItem__Badge-Container">';
      html += '<div class="ProductItem__Badge Text--alignCenter">';
      html += product_labels;
      html += '<svg viewBox="0 0 20 40"><polygon points="0,0 0,40 20,40 0,20 20,0"></polygon></svg>';
      html += '</div>';
      html += '</span>';
    }
  }
  return html;
}

function buildInfo(data, indx) {
  var html = '';
  var isPreOrderItem = false;
  var isFitTag = false;
  var fitTagValue = "";
  data.tags.forEach(tag => {
    if (tag.indexOf('pre-order') > -1) {
      isPreOrderItem = true;
    }
    if (tag.indexOf('Fit_') > -1) {
      isFitTag = true;
      fitTagValue = tag.replace("Fit_","");
    }
  });
  console.log("isFitTag : ",data);
  // Log product metafield custom.promotional_message
  var promotionalMessage = bcsffilter.getProductMetafield(data, 'custom', 'promotional_message');
  var promotionalMessageMobile = bcsffilter.getProductMetafield(data, 'custom', 'promotional_message_mobile');
  console.log('custom.promotional_message:', promotionalMessage);
  // Fallback: fetch metafield via product view when not available in dataset
  if (promotionalMessage == null && data && (data.url || data.handle)) {
    var productUrl = data.url || ('/products/' + data.handle);
    var promoViewUrl = productUrl + '?view=promotional-message';
    try {
      fetch(promoViewUrl, { credentials: 'same-origin' })
        .then(function(r){ return r.text(); })
        .then(function(txt){
          var json = null;
          try { json = JSON.parse(txt); } catch(_err) { json = null; }
          if (!json) {
            console.warn('promotional-message view returned non-JSON response');
            return;
          }
          var msg = json.promotional_message || json.promotional_message_global || json.promotional_message_customAttributes || json.first_variant_promotional_message || null;
          console.log('custom.promotional_message (ajax):', msg, json);
          var el = document.getElementById('promo-' + data.id);
          if (el && msg) {
            el.textContent = msg;
            el.classList.add('show_promo');
          }
        })
        .catch(function(err){
          console.warn('Failed to fetch promotional_message view', err);
        });
    } catch (e) {
      console.warn('Error starting promotional_message fetch', e);
    }
  }
    if (promotionalMessageMobile == null && data && (data.url || data.handle)) {
    var productUrl = data.url || ('/products/' + data.handle);
    var promoViewUrl = productUrl + '?view=promotional-message-mobile';
    try {
      fetch(promoViewUrl, { credentials: 'same-origin' })
        .then(function(r){ return r.text(); })
        .then(function(txt){
          var json = null;
          try { json = JSON.parse(txt); } catch(_err) { json = null; }
          if (!json) {
            console.warn('promotional-message-mobile view returned non-JSON response');
            return;
          }
          var msg = json.promotional_message_mobile || json.promotional_message_mobile_global || json.promotional_message_mobile_customAttributes || json.first_variant_promotional_message_mobile || null;
          console.log('custom.promotional_message_mobile (ajax):', msg, json);
          var el = document.getElementById('mobile-promo-' + data.id);
          if (el && msg) {
            el.textContent = msg;
            el.classList.add('show_promo');
          }
        })
        .catch(function(err){
          console.warn('Failed to fetch promotional_message_mobile view', err);
        });
    } catch (e) {
      console.warn('Error starting promotional_message_mobile fetch', e);
    }
  }
  if (bcSfFilterConfig.custom.show_product_info) {
    var infoClass = (!bcSfFilterConfig.custom.use_horizontal) ? 'ProductItem__Info--' + bcSfFilterConfig.custom.product_info_alignment : '';
    html += '<div class="ProductItem__Info ' + infoClass + ' ">';
    if (bcSfFilterConfig.custom.show_vendor) {
      html += '<p class="ProductItem__Vendor Heading">' + data.vendor + '</p>'
    }
    html += '<h2 class="ProductItem__Title Heading">';
    html += '<a href="{{itemUrl}}">' + data.title + '</a>';
    html += '</h2>';          
    html += buildPrice(data);
    html += '<div class="product-promotional-message" id="promo-' + data.id + '">' + (promotionalMessage ? promotionalMessage : '') + '</div>';
    html += '<div class="product-promotional-message mobile-promo" id="mobile-promo-' + data.id + '">' + (promotionalMessageMobile ? promotionalMessageMobile : '') + '</div>';  
    // Sub-title
    var metaSubTitle = bcsffilter.getProductMetafield(data, 'global', 'Subtitle');
    var metaSubTitle2 = bcsffilter.getProductMetafield(data, 'customAttributes', 'fit');
    // Always render container so AJAX fallback can populate later
    
    if (metaSubTitle !== null) {
      html += '<div class="product-subtitle">' + metaSubTitle + '</div>';
    } else if (metaSubTitle2 !== null) {
      html += '<div class="product-subtitle">' + metaSubTitle2 + '</div>';
    } else if (isFitTag) {
      html += '<div class="product-subtitle">' + fitTagValue + '</div>';
    }
    
    if (isPreOrderItem && bcSfFilterConfig.general.preOrderEnabled) {
      html += '<p class="pre-order-text Price--highlight u-h6">'+ bcSfFilterConfig.general.preOrderText+ '</p>';
    }
    html += '<a href="{{itemUrl}}"><div class="grid-view-item__reviews"><div class="yotpo bottomLine" data-appkey="gbc8edPA2EGWB0qcRI5zMuRWhSRv4JOyO1RaW9nt" data-domain="{{itemDomain}}" data-product-id="{{itemId}}" data-product-models="{{itemId}}" data-name="{{itemTitle}}" data-url="{{itemUrl}}" data-image-url="{{itemThumbUrl}}" data-description="{{itemDescription}}" data-bread-crumbs="{{itemTags}}"> </div></div></a>';
    if (bcSfFilterConfig.custom.show_color_swatch) {
      html += buildSwatch(data, bcsffilter, indx);	
    }
    html += '</div>';
  }
  return html;
}

function buildSwatch(data, ob, indx) {
 
  var _this = ob;
  var itemSwatchHtml = '';
  var counter = 0;
  var productid = data.id;
  if (bcSfFilterConfig.custom.show_color_swatch) {
    var color_name = bcSfFilterConfig.custom.section_id + '-' + data.id + '-' + indx;
    var lastVariantSku = {};
    data.variants.forEach(variant => {
      lastVariantSku[variant.option_color] = variant.sku;
    });
    data.options_with_values.forEach(function (option, index) {
      var option_name = option.name.toLowerCase();
      if (option_name.indexOf('color') != -1 || option_name.indexOf('colour') != -1 || option_name.indexOf('couleur') != -1) {
        var values = '';
        itemSwatchHtml += '<div class="ProductItem__ColorSwatchList">';
        var i = 0;
        data.variants.forEach(function (variant) {
		      

          var temp = variant.merged_options.filter(function (obj) {
            obj = obj.toLowerCase();
            if (obj.indexOf('color') != -1 || obj.indexOf('colour') != -1)
              return obj;
          });
          temp = temp[0].split(':');

          var value = temp[1].toLowerCase();
          if (values.indexOf(value) == -1) {
            
            values = values + ',' + value;
            values = values.split(',');
            var size = '200,400,600,700,800,900,1000,1200';
            var supported_sizes = imageSize(size, variant.image);
            var color_image = _this.optimizeImage(variant.image);
            var name_color = bcsffilter.slugify(value) + '.png';
            var checked = (i == 0) ? 'checked=checked' : '';
            var imageInfo = null;
            var image_aspect_ratio = 1;
            imageInfo = data.images_info.find(function (imageOb) {
              if (imageOb.src == variant.image){
              	image_aspect_ratio = imageOb.width / imageOb.height;
                return imageOb;
              } 
            });
            if (!imageInfo){
              if (data.images_info.length > 0){
              	imageInfo = data.images_info[0];
              } else {
              	imageInfo = {
                	src: bcSfFilterConfig.general.no_image_url,
                  	id: variant.id,
                  	width: 480,
                  	height: 480
              	}
              }

            }
            var dataImg = (imageInfo != null) ? '" data-image-url="' + imageInfo.src + '" data-image-widths="[' + supported_sizes + ']" data-image-aspect-ratio="1" data-image-id="' + imageInfo.id + '"' : '';
            var color_input_id = color_name + "-" + values.length;
            var variant_price = variant.price ? Math.round(variant.price) : 0;
            var variant_compare_at_price = variant.compare_at_price ? Math.round(variant.compare_at_price) : 0;
             value = value[0].toUpperCase() + value.slice(1);

            var url_data = '/'+lastVariantSku[variant.option_color]+'_'+value.replace(' ', '-') + '_64x64.jpg?';
            var url_data_new = '/'+lastVariantSku[variant.option_color]+'_'+value.toUpperCase().replace(' ', '-') + '_64x64.jpg?';

            itemSwatchHtml += '<div class="ProductItem__ColorSwatchItem">';
            itemSwatchHtml += '<input prod-id="'+ productid +'" class="ColorSwatch__Radio ColorSwatch__Radio--boost" type="radio" ' + checked + ' name="' + color_name + '" id="' + color_input_id + '" value="' + value + '" data-image-aspect-ratio="' + image_aspect_ratio + '" data-variant-price="' + variant_price + '" data-variant-compare-at-price="' + variant_compare_at_price + '" data-variant-url="' + _this.buildProductItemUrl(data) + '?variant=' + variant.id + '#Image' +  imageInfo.id + '"' + dataImg + '  aria-hidden="true">';
            itemSwatchHtml += '<label class="ColorSwatch ColorSwatch--small" for="' + color_input_id + '" style="background-color: ' + value.replace(' ', '').toLowerCase() + ';" title="' + value + '" data-tooltip="' + value.toUpperCase() + '" data-image-data="' + url_data + '" data-image-data-new="' + url_data_new + '"></label>';
            itemSwatchHtml += '</div>';
            counter++;
            i++;
          }
        });
        itemSwatchHtml += '</div>';
      }
    });
  }
  if(counter > 1){
  	return itemSwatchHtml;
  }else{
  	return '';
  }
}
/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
/************************** BUILD TOOLBAR **************************/
// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
  // Get page info
  var currentPage = parseInt(this.queryParams.page);
  var totalPage = Math.ceil(totalProduct / this.queryParams.limit);
  // If it has only one page, clear Pagination
  if (totalPage == 1) {
    jQ(this.selector.pagination).html('');
    return false;
  }
  if (this.getSettingValue('general.paginationType') == 'default') {
    var paginationHtml = bcSfFilterTemplate.paginateHtml;
    // Build Previous
    var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
    previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
    // Build Next
    var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisabledHtml;
    nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
    // Create page items array
    var beforeCurrentPageArr = [];
    for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
      beforeCurrentPageArr.unshift(iBefore);
    }
    if (currentPage - 4 > 0) {
      beforeCurrentPageArr.unshift('...');
    }
    if (currentPage - 4 >= 0) {
      beforeCurrentPageArr.unshift(1);
    }
    beforeCurrentPageArr.push(currentPage);
    var afterCurrentPageArr = [];
    for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
      afterCurrentPageArr.push(iAfter);
    }
    if (currentPage + 3 < totalPage) {
      afterCurrentPageArr.push('...');
    }
    if (currentPage + 3 <= totalPage) {
      afterCurrentPageArr.push(totalPage);
    }
    // Build page items
    var pageItemsHtml = '';
    var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
    for (var iPage = 0; iPage < pageArr.length; iPage++) {
      if (pageArr[iPage] == '...') {
        pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
      } else {
        pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
      }
      pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
      pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
    }
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
    paginationHtml = jQ.parseHTML(paginationHtml);
    jQ(this.selector.pagination).html(paginationHtml);
  }
};

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
  if (bcSfFilterConfig.custom.show_sorting && bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
    jQ(this.selector.topSorting).html('');
    var sortingArr = this.getSortingList();
    if (sortingArr) {
      // Build content
      var sortingItemsHtml = '';
      for (var k in sortingArr) {
        var classActive = (this.queryParams.sort == k) ? 'is-selected' : '';
        sortingItemsHtml
          += '<button class="Popover__Value '
          + classActive + ' Heading Link Link--primary u-h6" data-value="' + k
          + '" role="option" aria-selected="'
          + ((this.queryParams.sort == k) ? 'true"' : 'false"')
          + '>' + sortingArr[k] + '</button>';
      }
      var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      html = jQ.parseHTML(html);
      jQ(this.selector.topSorting).html(html);
    }
  }
};

// Build Sorting event
BCSfFilter.prototype.buildSortingEvent = function() {
  var _this = this;
  var topSortingSelector = jQ(this.selector.topSorting);
  topSortingSelector.find('.Popover__Value').click(function(e) {
    onInteractWithToolbar(e, 'sort', _this.queryParams.sort, jQ(this).data('value'));
    jQ('.CollectionToolbar__Item--sort').trigger('click');
    jQ(this).siblings().attr('aria-selected', 'false');
    jQ(this).attr('aria-selected', 'true');
  })
};

/************************** END BUILD TOOLBAR **************************/

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {
  /**
   *  Call theme function 
   *  1. Add var bcPrestigeSections; var bcPrestigeSectionContainer; to assets/theme.min.js
   *  2. In assets/theme.min.js, find var YYY=new XXX.SectionContainer; For example: var e=new o.SectionContainer;
   *  3. Replace var e=new o.SectionContainer; by var e=new o.SectionContainer; var YYY = new XXX.SectionContainer;  bcPrestigeSections = YYY; bcPrestigeSectionContainer = XXX;
  
  if(typeof bcPrestigeSectionContainer != 'undefined' && typeof bcPrestigeSections != 'undefined'){
    bcPrestigeSections.register("collection", bcPrestigeSectionContainer.CollectionSection);
    bcPrestigeSections.register("search", bcPrestigeSectionContainer.SearchSection);
  }  
  */
  var self = this;
  /** Start Swym integration **/
  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(function(swat) { 
          // Wrap with callback for loading without additional checks
      var products = [];
      data.forEach(function(product) {
          var image_src = self.getFeaturedImage(product.images);
          var productCopy = product;
          productCopy.featured_image = image_src;
          products.push(productCopy);
      });
      swat.mapShopifyProducts(products); // Product mapped data to swym layer
      swat.initializeActionButtons(self.getSelector('products')); // Buttons can now be initialized
  });
  /** End Swym integration **/

  // Fix image not load on Instagram browser - initialize swatch image
  jQ(".ProductItem__Info .ProductItem__ColorSwatchList .ProductItem__ColorSwatchItem label.ColorSwatch").click(function(){
    if (!(this).hasClass('active')) {
      jQ(this).parent().parent().find('label.ColorSwatch').removeClass('active');
      jQ(this).addClass('active');
      var parent = jQ(this).parent();
      var productImage = jQ(this).parent().parent().parent().parent().find('a.ProductItem__ImageWrapper');
      var variantInfo = parent.find('input.ColorSwatch__Radio');
      productImage.find('.AspectRatio .bc-sf-product-swatch-img').remove();
      productImage.find('.AspectRatio').prepend(jQ.parseHTML('<img class="bc-sf-product-swatch-img" src="' + variantInfo.data('image-url') + '" />'));
      productImage.find('img.ProductItem__Image').hide();
      productImage.attr('href', variantInfo.data('variant-url'));
      var variantPrice = '';
      if (variantInfo.data('variant-compare-at-price') > variantInfo.data('variant-price')){
        variantPrice += '<span class="ProductItem__Price Price Price--highlight Text--subdued" data-money-convertible="">' + bcsffilter.formatMoney(variantInfo.data('variant-price'), bcsffilter.moneyFormat(), true) + '</span>'
        variantPrice += '<span class="ProductItem__Price Price Price--compareAt Text--subdued" data-money-convertible="">' + bcsffilter.formatMoney(variantInfo.data('variant-compare-at-price'), bcsffilter.moneyFormat(), true) + '</span>';
      } else {
        variantPrice += '<span class="ProductItem__Price Price Text--subdued" data-money-convertible>' + bcsffilter.formatMoney(variantInfo.data('variant-price'), bcsffilter.moneyFormat(), true) + '</span>';
        variantPrice += '<span class="ProductItem__Price Price Price--compareAt Text--subdued" data-money-convertible="" style="display:none"></span>';
      }
      variantPrice = jQ.parseHTML(variantPrice);
      jQ(this).closest('.ProductItem__Wrapper').find('.ProductItem__PriceList').html(variantPrice);
    }
    return false;
  })
  
  jQ('.ProductItem__Wrapper').mouseenter(function(e) {
    e.preventDefault();
    if( jQ(this).find("#video-tag").length > 0 ){
      jQ(this).find('a.ProductItem__ImageWrapper img').hide();
      jQ(this).find("#video-tag").show();
      jQ(this).find('video').get(0).play();
    }
  }).mouseleave(function(e) {
    e.preventDefault();
    if( jQ(this).find("#video-tag").length > 0 ){
      jQ(this).find('a.ProductItem__ImageWrapper img').show();
      jQ(this).find("#video-tag").hide();
      jQ(this).find('video').get(0).pause();
    }
  });
  
  // Call function to get extra product html by ajax
  // this.buildExtrasProductListByAjax(data, 'boost-integration', function(results){
  //   results.forEach(function(result){
  //    // Append the custom html to product item
  //    // console.log(result.yotpo_html);
  //    // jQ('[data-product-id="'+ result.id+ '"] .yotpo-html').html(result.yotpo_html);
  //     jQ('[data-product-id="'+ result.id+ '"] .product-subtitle').html(result.product_subtitle);
  //   })
  // })
};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
  // Build product count on search page
  if (bcsffilter.queryParams && bcsffilter.queryParams.q){
    var productCountText = '';		
    switch (data.total_product){
      case 0:
          productCountText = bcSfFilterConfig.label.search_results_zero;
          break;
      case 1:
          productCountText = bcSfFilterConfig.label.search_results_one;
          break; 
      default:
          productCountText = bcSfFilterConfig.label.search_results_other;
          break; 
    }

    var searchTerm = bcsffilter.queryParams.q.replace('*', '');
    productCountText = productCountText.replace(/{{terms}}/, searchTerm);
    productCountText = productCountText.replace(/{{count}}/, data.total_product);
	  jQ("#bc-sf-product-count").html(productCountText);
  }
  if (typeof Yotpo !== 'undefined') {
      var api = new Yotpo.API(yotpo);
      api.refreshWidgets();
  }
};

// Build Default layout
BCSfFilter.prototype.buildDefaultElements=function(){var isiOS=/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream,isSafari=/Safari/.test(navigator.userAgent),isBackButton=window.performance&&window.performance.navigation&&2==window.performance.navigation.type;if(!(isiOS&&isSafari&&isBackButton)){var self=this,url=window.location.href.split("?")[0],searchQuery=self.isSearchPage()&&self.queryParams.hasOwnProperty("q")?"&q="+self.queryParams.q:"";window.location.replace(url+"?view=bc-original"+searchQuery)}};

function customizeJsonProductData(data) {for (var i = 0; i < data.variants.length; i++) {var variant = data.variants[i];var featureImage = data.images.filter(function(e) {return e.src == variant.image;});if (featureImage.length > 0) {variant.featured_image = {"id": featureImage[0]['id'],"product_id": data.id,"position": featureImage[0]['position'],"created_at": "","updated_at": "","alt": null,"width": featureImage[0]['width'], "height": featureImage[0]['height'], "src": featureImage[0]['src'], "variant_ids": [variant.id]}} else {variant.featured_image = '';};};var self = bcsffilter;var itemJson = {"id": data.id,"title": data.title,"handle": data.handle,"vendor": data.vendor,"variants": data.variants,"url": self.buildProductItemUrl(data),"options_with_values": data.options_with_values,"images": data.images,"images_info": data.images_info,"available": data.available,"price_min": data.price_min,"price_max": data.price_max,"compare_at_price_min": data.compare_at_price_min,"compare_at_price_max": data.compare_at_price_max};return itemJson;};
BCSfFilter.prototype.prepareProductData=function(data){var self=this;var countData=data.length;for(var k=0;k<countData;k++){data[k]["images"]=data[k]["images_info"];if(data[k]["images"].length>0){data[k]["featured_image"]=data[k]["images"][0]}else{data[k]["featured_image"]={src:bcSfFilterConfig.general.no_image_url,width:"",height:"",aspect_ratio:0}}data[k]["url"]="/products/"+data[k].handle;var optionsArr=[];var countOptionsWithValues=data[k]["options_with_values"].length;for(var i=0;i<countOptionsWithValues;i++){optionsArr.push(data[k]["options_with_values"][i]["name"])}data[k]["options"]=optionsArr;var firstVariant=data[k]["variants"][0];var isRoundedPrice=true;if(firstVariant.hasOwnProperty("fulfillment_service")&&firstVariant.fulfillment_service=="gift_card"){isRoundedPrice=false}if(typeof self.convertPriceBasedOnActiveCurrency!=="undefined"){data[k].price_min=self.convertPriceBasedOnActiveCurrency(data[k].price_min,isRoundedPrice);data[k].price_max=self.convertPriceBasedOnActiveCurrency(data[k].price_max,isRoundedPrice);data[k].compare_at_price_min=self.convertPriceBasedOnActiveCurrency(data[k].compare_at_price_min,isRoundedPrice);data[k].compare_at_price_max=self.convertPriceBasedOnActiveCurrency(data[k].compare_at_price_max,isRoundedPrice)}data[k]["price_min"]*=100,data[k]["price_max"]*=100;if(data[k]["compare_at_price_min"]!=null){data[k]["compare_at_price_min"]*=100}if(data[k]["compare_at_price_max"]!=null){data[k]["compare_at_price_max"]*=100}data[k]["price"]=data[k]["price_min"];data[k]["compare_at_price"]=data[k]["compare_at_price_min"];data[k]["price_varies"]=data[k]["price_min"]!=data[k]["price_max"];if(getParam("variant")!==null&&getParam("variant")!=""){var paramVariant=data[k]["variants"].filter(function(e){return e.id==getParam("variant")});if(typeof paramVariant[0]!=="undefined")firstVariant=paramVariant[0]}else{var countVariants=data[k]["variants"].length;for(var i=0;i<countVariants;i++){if(data[k]["variants"][i].available){firstVariant=data[k]["variants"][i];break}}}data[k]["selected_or_first_available_variant"]=firstVariant;var countVariants=data[k]["variants"].length;for(var i=0;i<countVariants;i++){var variantOptionArr=[];var count=1;var variant=data[k]["variants"][i];var variantOptions=variant["merged_options"];if(Array.isArray(variantOptions)){var countVariantOptions=variantOptions.length;for(var j=0;j<countVariantOptions;j++){var temp=variantOptions[j].split(":");data[k]["variants"][i]["option"+(parseInt(j)+1)]=temp[1];data[k]["variants"][i]["option_"+temp[0]]=temp[1];variantOptionArr.push(temp[1])}data[k]["variants"][i]["options"]=variantOptionArr}if(data[k]["variants"][i]["compare_at_price"]!=null){var variantCompareAtPrice=parseFloat(data[k]["variants"][i]["compare_at_price"]);if(typeof self.convertPriceBasedOnActiveCurrency!=="undefined"){variantCompareAtPrice=self.convertPriceBasedOnActiveCurrency(variantCompareAtPrice,isRoundedPrice)}data[k]["variants"][i]["compare_at_price"]=variantCompareAtPrice*100}var variantPrice=parseFloat(data[k]["variants"][i]["price"]);if(typeof self.convertPriceBasedOnActiveCurrency!=="undefined"){variantPrice=self.convertPriceBasedOnActiveCurrency(variantPrice,isRoundedPrice)}data[k]["variants"][i]["price"]=variantPrice*100}data[k]["description"]=data[k]["content"]=data[k]["body_html"];if(data[k].hasOwnProperty("original_tags")&&data[k]["original_tags"].length>0){data[k]["tags"]=data[k]["original_tags"].slice(0)}data[k]["json"]=customizeJsonProductData(data[k])}return data};
/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */


BCSfFilter.prototype.buildProductListData = function(e, t) {
  (this.isDefaultPaginationType() || !this.isDefaultPaginationType() && "page" != t) && (jQ(this.getSelector("products")).html(""), jQ(window).unbind("scroll"));
  for (var i = "", r = e.length, n = 0; n < r; n++) {
    switch (this.queryParams.display) {
      case "list":
        var a = this.buildProductListItem(e[n], n + 1, r);
        break;
      case "collage":
        var a = this.buildProductCollageItem(e[n], n + 1, r);
        break;
      default:
        var a = this.buildProductGridItem(e[n], n + 1, r)
    }
    i += this.buildProductItemAdvanced(e[n], a)
  }
  this.buildProductListDataHtml(i);


  window.setTimeout( function() {
    var swatches = $(document).find('#bc-sf-filter-products .ProductItem__ColorSwatchItem label.ColorSwatch');
    if( swatches.length > 0 ) {
      swatches.each(function( index ) {
        var self = $(this);

        var image_data = self.attr('data-image-data');
        var image_data_new = self.attr('data-image-data-new');

        if (image_data != '') {
          var url_color = bcSfFilterMainConfig.general.file_url.replace('/?', image_data);

          /** check if image is available or not in that location */
          $.ajax({
            url: url_color,
            type: 'HEAD',
            async: true,
            success: function () {
              self.css('background-image', 'url(' + url_color + ')');
            },
            error: function () {
              if( image_data_new != '') {
                var url_color_new = bcSfFilterMainConfig.general.file_url.replace('/?', image_data_new);
                $.ajax({
                  url: url_color_new,
                  type: 'HEAD',
                  async: true,
                  success: function(){
                    self.css('background-image', 'url(' + url_color_new + ')');
                  }
                });
              }
            }
          });
        }
      });
    }
  }, 500 );

}